import XfyLayout from '@/layouts/xfy'

let routes = [
  {
    name: 'xfy',
    path: '/',
    redirect: '/download',
    component: XfyLayout,
    children: [
      {
        name: 'xfyDownload',
        path: '/download',
        component: () => import('_xfy/download'),
        meta: {
          title: '幸福苑APP'
        }
      },
      {
        name: 'notice5',
        path: '/notice5',
        component: () => import('_xfy/notice/imgNotice'),
        meta: { title: '公告' }
      },
      {
        name: 'textNotice',
        path: '/notice:index',
        component: () => {
          console.log(this)
          return import('_xfy/notice/txtNotice')
        },
        meta: { title: '公告' }
      },
      {
        name: 'imageNotice',
        path: '/:folder-:file-details',
        component: () => import('_xfy/notice/imgNotice'),
        meta: { title: '公告' }
      }
    ]
  }
]

export default routes
